// src/pages/Coaching.jsx

import { motion } from "framer-motion";
import marriageImg from "../../assets/optimized/mjkim-new.webp";
import Button from "../../components/ui/button";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import flyer from "../../assets/couple.png";

export default function CoachingPage() {
    const navigate = useNavigate();
  return (
    <>
          <Helmet>
        <title>Relationship Coaching | Pure Business Solutions</title>

        <meta
          name="description"
          content="Strengthen your marriage, relationships, and communication through biblical coaching from Pure Business Solutions."
        />

        <link
          rel="canonical"
          href="https://www.pbizs.com/coaching"
        />

        <meta property="og:title" content="Relationship Coaching" />
        <meta property="og:url" content="https://www.pbizs.com/coaching" />
      </Helmet>
      {/* ================= HERO ================= */}
      <section className="relative overflow-hidden bg-gradient-to-br from-[#FDF8F2] via-white to-[#FFF5EE] py-24 lg:py-36">

        {/* Background Glow */}
        <div className="absolute -top-40 -left-32 w-[500px] h-[500px] bg-[#D4AF37]/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-[#BE2D69]/10 rounded-full blur-3xl"></div>

        <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-20 items-center">

          {/* Left */}
          <motion.div
            initial={{ opacity: 0, x: -80 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: .8 }}
          >

            <span className="uppercase tracking-[6px] text-[#D4AF37] font-semibold">
              Christian Marriage & Relationship Coaches
            </span>

            <h1 className="text-6xl lg:text-7xl font-bold text-[#2C2C2C] mt-6 leading-tight">
              Helping Couples
              <br />
              Move From
              <br />
              <span className="text-[#BE2D69]">
                Surviving
              </span>
              {" "}
              To
              {" "}
              <span className="text-[#D4AF37]">
                Flourishing
              </span>
            </h1>

            <div className="w-28 h-1 bg-[#D4AF37] rounded-full my-8"></div>

            <p className="text-xl leading-9 text-gray-600 max-w-xl">
              Faith-based coaching designed to help couples reconnect,
              communicate, heal, and build stronger relationships through
              biblical wisdom and practical life strategies.
            </p>

            <div className="flex flex-wrap gap-5 mt-12">

              <button
                onClick={() => navigate("/contact")}
                className="bg-[#BE2D69] hover:bg-[#A81F5C] text-white px-10 py-5 rounded-full font-bold shadow-xl transition-all duration-300 hover:scale-105"
              >
                Schedule a Session
              </button>

              <button
                onClick={() => navigate("/retreats")}
                className="border-2 border-[#D4AF37] text-[#2C2C2C] hover:bg-[#D4AF37] hover:text-white px-10 py-5 rounded-full font-bold transition-all duration-300"
              >
                View Retreats
              </button>

            </div>

          </motion.div>

          {/* Right */}

          <motion.div
            initial={{ opacity: 0, x: 80 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: .8 }}
            className="relative"
          >

            <div className="absolute inset-0 rounded-[50px] bg-[#D4AF37]/20 blur-3xl scale-105"></div>

            <img
              src={flyer}
              alt="Maurice and Kim"
              className="relative rounded-[40px] shadow-2xl w-full object-cover"
            />

          </motion.div>

        </div>

      </section>
      {/* ================= TRUST SECTION ================= */}

<section className="relative bg-white py-20 overflow-hidden">

  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#D4AF37]/5 rounded-full blur-3xl"></div>

  <div className="relative max-w-7xl mx-auto px-6">

    {/* Heading */}

    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: .7 }}
      viewport={{ once: true }}
      className="text-center"
    >

      <span className="uppercase tracking-[5px] text-[#D4AF37] font-semibold">
        Why Couples Trust Maurice & Kim
      </span>

      <h2 className="text-5xl font-bold text-[#2C2C2C] mt-5">
        Experience That Builds
        <br />
        Stronger Relationships
      </h2>

      <div className="w-24 h-1 bg-[#D4AF37] rounded-full mx-auto mt-8"></div>

      <p className="text-gray-600 text-lg max-w-3xl mx-auto mt-8 leading-9">
        After more than twenty-seven years of marriage and over a decade
        of coaching couples, Maurice and Kim combine biblical truth with
        practical relationship strategies that inspire lasting change.
      </p>

    </motion.div>

    {/* Stats */}

    <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8 mt-20">

      {[
        {
          number: "27+",
          title: "Years Married",
          text: "Living the principles they teach."
        },
        {
          number: "10+",
          title: "Years Coaching",
          text: "Helping couples reconnect and thrive."
        },
        {
          number: "Faith",
          title: "Christ Centered",
          text: "Biblical truth guides every session."
        },
        {
          number: "100%",
          title: "Personalized",
          text: "Every couple receives customized coaching."
        },
      ].map((item, index) => (

        <motion.div
          key={index}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            duration: .7,
            delay: index * .15,
          }}
          viewport={{ once: true }}
          whileHover={{
            y: -10,
            scale: 1.03,
          }}
          className="
          bg-[#FFF9F2]
          rounded-[35px]
          shadow-xl
          p-10
          border
          border-[#D4AF37]/20
          text-center
          transition-all
          duration-300
          "
        >

          <h3 className="text-6xl font-black text-[#BE2D69]">
            {item.number}
          </h3>

          <h4 className="text-2xl font-bold text-[#2C2C2C] mt-6">
            {item.title}
          </h4>

          <p className="text-gray-600 leading-8 mt-5">
            {item.text}
          </p>

        </motion.div>

      ))}

    </div>

  </div>

</section>
{/* ================= ABOUT MAURICE & KIM ================= */}

<section className="relative bg-gradient-to-br from-[#F8F3ED] via-white to-[#FFF9F4] py-28 overflow-hidden">

  <div className="absolute -left-32 top-10 w-[450px] h-[450px] rounded-full bg-[#D4AF37]/10 blur-3xl"></div>

  <div className="absolute right-0 bottom-0 w-[500px] h-[500px] rounded-full bg-[#BE2D69]/10 blur-3xl"></div>

  <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-20 items-center">

    {/* IMAGE */}

    <motion.div
      initial={{ opacity: 0, x: -70 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: .8 }}
      viewport={{ once: true }}
      className="relative"
    >

      <div className="absolute inset-0 bg-[#D4AF37]/20 rounded-[45px] blur-3xl"></div>

      <img
        src={marriageImg}
        alt="Maurice and Kim Johnson"
        className="
        relative
        rounded-[40px]
        shadow-2xl
        w-full
        object-cover
        "
      />

    </motion.div>

    {/* CONTENT */}

    <motion.div
      initial={{ opacity: 0, x: 70 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: .8 }}
      viewport={{ once: true }}
    >

      <span className="uppercase tracking-[6px] text-[#D4AF37] font-semibold">

        Meet Your Coaches

      </span>

      <h2 className="text-5xl font-bold text-[#2C2C2C] mt-5 leading-tight">

        Maurice & Kim
        <br />
        Johnson

      </h2>

      <div className="w-24 h-1 bg-[#D4AF37] rounded-full my-8"></div>

      <p className="text-lg text-gray-600 leading-9">

        Maurice and Kim Johnson have spent over twenty-seven years
        building a marriage rooted in faith, resilience, and intentional
        growth. Their passion is helping couples strengthen
        communication, rebuild trust, deepen intimacy, and create
        relationships that honor God.

      </p>

      <p className="text-lg text-gray-600 leading-9 mt-6">

        Their coaching blends biblical principles with practical tools,
        helping couples navigate conflict, restore connection, prepare
        for marriage, and flourish through every season of life.

      </p>

      {/* FEATURES */}

      <div className="grid sm:grid-cols-2 gap-6 mt-12">

        {[
          {
            title: "Faith Centered",
            text: "Every session is grounded in biblical truth."
          },
          {
            title: "Practical Tools",
            text: "Real strategies that couples can apply immediately."
          },
          {
            title: "Safe Environment",
            text: "Compassionate coaching without judgment."
          },
          {
            title: "Personalized Plans",
            text: "Every relationship receives individualized guidance."
          }

        ].map((item, index) => (

          <motion.div
            key={index}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              delay: index * .15,
              duration: .6
            }}
            viewport={{ once: true }}
            whileHover={{
              y: -6,
              scale: 1.02
            }}
            className="
            bg-white
            rounded-[25px]
            p-6
            shadow-lg
            border
            border-[#D4AF37]/20
            "
          >

            <h3 className="text-xl font-bold text-[#BE2D69]">

              {item.title}

            </h3>

            <p className="text-gray-600 mt-3 leading-7">

              {item.text}

            </p>

          </motion.div>

        ))}

      </div>

    </motion.div>

  </div>

</section>

{/* ================= COACHING SERVICES ================= */}

<section className="relative bg-white py-28 overflow-hidden">

  <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-[#D4AF37]/10 rounded-full blur-3xl"></div>
  <div className="absolute bottom-0 right-0 w-[450px] h-[450px] bg-[#BE2D69]/10 rounded-full blur-3xl"></div>

  <div className="relative max-w-7xl mx-auto px-6">

    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: .7 }}
      viewport={{ once: true }}
      className="text-center"
    >

      <span className="uppercase tracking-[6px] text-[#D4AF37] font-semibold">
        Coaching Services
      </span>

      <h2 className="text-5xl font-bold text-[#2C2C2C] mt-5">
        How We Can Help You
      </h2>

      <div className="w-24 h-1 bg-[#D4AF37] rounded-full mx-auto my-8"></div>

      <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-9">
        Whether you're preparing for marriage, rebuilding after
        challenges, or simply looking to strengthen your relationship,
        we provide personalized coaching designed to help you flourish.
      </p>

    </motion.div>

    <div className="grid lg:grid-cols-2 gap-10 mt-20">

      {[
        {
          icon: "❤️",
          title: "Marriage Coaching",
          text: "Strengthen communication, rebuild trust, resolve conflict, and deepen your connection through practical, faith-based coaching."
        },

        {
          icon: "💍",
          title: "Premarital Coaching",
          text: "Prepare for a strong, lasting marriage by building healthy habits, expectations, communication, and biblical foundations."
        },

        {
          icon: "👤",
          title: "Individual Coaching",
          text: "Receive personal guidance through life's challenges while growing emotionally, spiritually, and relationally."
        },

        {
          icon: "👨‍👩‍👧",
          title: "Family Relationship Coaching",
          text: "Build healthier family relationships, improve communication, and strengthen connections across every generation."
        }

      ].map((service, index) => (

        <motion.div
          key={index}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: index * .15,
            duration: .6
          }}
          viewport={{ once: true }}
          whileHover={{
            y: -10,
            scale: 1.02
          }}
          className="
          bg-[#FFF9F2]
          rounded-[35px]
          p-10
          shadow-xl
          border
          border-[#D4AF37]/20
          transition-all
          duration-300
          "
        >

          <div className="text-6xl">
            {service.icon}
          </div>

          <h3 className="text-3xl font-bold text-[#2C2C2C] mt-8">
            {service.title}
          </h3>

          <p className="text-gray-600 leading-9 mt-6">
            {service.text}
          </p>

          <button
            onClick={() => navigate("/contact")}
            className="
            mt-10
            bg-[#BE2D69]
            hover:bg-[#A8215B]
            text-white
            px-8
            py-4
            rounded-full
            font-semibold
            transition-all
            duration-300
            hover:scale-105
            "
          >
            Book This Service
          </button>

        </motion.div>

      ))}

    </div>

  </div>

</section>
    </>
  );
}
